<template>
  <div class="main-content">
    <div class="stat">
      <div class="cell">
        <div class="title">总资产</div>
        <div class="value">
          {{ (jinNangDetail.totalAmount / 10000.0).toFixed(2) }}
        </div>
      </div>
      <div class="cell-split"></div>
      <div class="cell">
        <div class="title">总市值</div>
        <div class="value">
          {{ (jinNangDetail.marketValueAmount / 10000.0).toFixed(2) }}
        </div>
      </div>
      <div class="cell">
        <div class="title">可用资金</div>
        <div class="value">
          {{ (jinNangDetail.avaliableAmount / 10000.0).toFixed(2) }}
        </div>
      </div>
      <div class="cell-split"></div>
      <div class="cell">
        <div class="title">仓位</div>
        <div class="value">{{ jinNangDetail.totalPosition }}</div>
      </div>
      <div class="cell">
        <div class="title">持仓盈亏</div>
        <div
          :class="{
            c1: getSymbol(totalGailLoss) > 0,
            c3: getSymbol(totalGailLoss) <= 0,
            value: true
          }"
        >
          {{ totalGailLoss }}
        </div>
      </div>
    </div>
    <div class="hrsplit"></div>
    <div class="chart-collapse">
      <div v-if="!ischartCollapse">
        <div class="chart-filter">
          <div
            v-for="(item, index) in chartFilter"
            :key="index"
            :class="[
              {
                'filter-select': index === currentRangeFilterIndex,
                'filter-item': true
              }
            ]"
            @click="selectRange(index)"
          >
            {{ item.text }}
          </div>
        </div>
        <div id="yieldChart" class="chart-content"></div>
      </div>
      <div class="collapse-tip" @click="chartToggle">
        {{ collapseTip }}
        <i
          :class="{
            'el-icon-arrow-down': ischartCollapse,
            'el-icon-arrow-up': !ischartCollapse,
            colortip: true
          }"
        ></i>
      </div>
    </div>

    <div
      :class="{
        mt40: !ischartCollapse
      }"
    >
      <jin-nang-repo-table
        :repo-list="repoList"
        :is-row-pointer="true"
        v-on:repo-selected="OnRepoClick"
      ></jin-nang-repo-table>
    </div>
  </div>
</template>

<script>
import {
  getJinNangYieldList,
  getJinNangDetail,
  getJinNangRepoList
} from '@/api/AuthorJinNang'
import dayjs from 'dayjs'
import JinNangRepoTable from './JinNangRepoTable.vue'

export default {
  name: 'AuthorJinNangRepo',
  components: { JinNangRepoTable },
  data() {
    return {
      chartFilter: [
        { text: '一月' },
        { text: '三月' },
        { text: '一年' },
        { text: '今年以来' },
        { text: '创建以来' }
      ],
      currentRangeFilterIndex: 0,
      tradeList: [],
      repoList: [],
      YieldList: [],
      jinNangDetail: {},
      viewState: '',
      dialogVisible: false,
      pageSize: 1000,
      pageIndex: 0,
      total: 0,
      orderby: 'desc',
      titleList: [
        { text: '证券代码', class: '' },
        { text: '证券名称', class: '' },
        { text: '证券数量', class: '' },
        { text: '可卖数量', class: '' },
        { text: '成本价（元）', class: '' },
        { text: '现价（元）', class: '' },
        { text: '浮动盈亏', class: '' },
        { text: '盈亏比例', class: '' },
        { text: '最新市值', class: '' },
        { text: '持仓比例', class: '' }
      ],
      ischartCollapse: true
    }
  },
  watch: {
    async currentRangeFilterIndex(newValue, oldValue) {
      await this.getYieldList(this.getFilterRange(newValue))
    }
  },
  created() {
    this.getJinNangPage()
  },
  computed: {
    currentJinNangId() {
      return this.$route.params.id
    },
    totalGailLoss() {
      if (this.repoList && this.repoList.length > 0) {
        return (
          this.repoList.map(a => a.totalGailLoss).reduce((a, b) => a + b) /
          10000
        )
      } else {
        return 0
      }
    },
    collapseTip() {
      if (this.ischartCollapse) {
        return '显示收益率曲线'
      } else {
        return '隐藏收益率曲线'
      }
    }
  },
  methods: {
    dayjs,
    async getJinNangPage() {
      this.jinNangDetail = await getJinNangDetail({
        jinNangId: this.currentJinNangId
      })
      await this.getJinNangRepoList()
    },
    getSymbol(number) {
      const dig = parseFloat(number)
      return dig
    },
    getSymbolClass(number) {
      var symblo = this.getSymbol(number)
      if (symblo > 0) {
        return 'c1'
      } else {
        return 'c3'
      }
    },
    async getYieldList(range) {
      const data = await getJinNangYieldList({
        jinNangId: this.currentJinNangId,
        range: range,
        type: 1,
        pageSize: 1000
      })
      if (data) {
        if (data.result.code === 0) {
          this.YieldList = data.detail
          this.renderYieldChart(this.YieldList.items)
        }
      }
    },
    async getJinNangRepoList() {
      const data = await getJinNangRepoList({
        jinNangId: this.currentJinNangId
      })
      if (data) {
        if (data.result.code === 0) {
          this.repoList = data.detail.items
        }
      }
    },
    groupBy(list, keyGetter) {
      const map = new Map()
      list.forEach(item => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return map
    },
    toPercent(point) {
      var str = Number(point * 100).toFixed(1)
      str += '%'
      return str
    },
    selectTradeFilter(index) {
      this.currentTabIndex = index
    },
    selectRange(index) {
      this.currentRangeFilterIndex = index
    },
    getFilterRange(index) {
      var now = this.dayjs()
      if (index === 0) {
        return parseInt(now.subtract(1, 'month').format('YYYYMMDD'))
      } else if (index === 1) {
        return parseInt(now.subtract(3, 'month').format('YYYYMMDD'))
      } else if (index === 2) {
        return parseInt(now.subtract(1, 'year').format('YYYYMMDD'))
      } else if (index === 3) {
        return parseInt(now.startOf('year').format('YYYYMMDD'))
      } else {
        return 0
      }
    },
    renderYieldChart(sourceData) {
      var yieldChart = this.$echarts.init(document.getElementById('yieldChart'))
      var glYieldSeriesDataArr = sourceData.map(a => a.glYield / 100.0)
      var indexSeriesDataArr = sourceData.map(a => a.indexYield / 100.0)
      const minValue = Math.floor(Math.min(...glYieldSeriesDataArr))
      if (minValue < 0) {
        glYieldSeriesDataArr = glYieldSeriesDataArr.map(a => {
          return (a - minValue).toFixed(2)
        })
        indexSeriesDataArr = indexSeriesDataArr.map(a => {
          return (a - minValue).toFixed(2)
        })
      }

      var xaxisData = sourceData.map(a =>
        a.tradeDate
          .toString()
          .split('')
          .slice(4, 6)
          .concat(['-'])
          .concat(
            a.tradeDate
              .toString()
              .split('')
              .slice(6)
          )
          .join('')
      )
      var option = {
        tooltip: {
          trigger: 'axis',
          // formatter: '{a0}: {c0}%<br />{a1}: {c1}%',
          formatter: function(params, ticket, callback) {
            return (
              params[0].seriesName +
              ':' +
              (minValue < 0
                ? (Number(params[0].value) + minValue).toFixed(2)
                : params[0].value) +
              '%<br />' +
              params[1].seriesName +
              ':' +
              (minValue < 0
                ? (Number(params[1].value) + minValue).toFixed(2)
                : params[1].value) +
              '%'
            )
          },
          axisPointer: {
            type: 'cross',
            label: {
              formatter: function(params) {
                if (params.axisDimension === 'y') {
                  return (
                    (params.value + (minValue < 0 ? minValue : 0)).toFixed(2) +
                    '%'
                  )
                } else {
                  return params.value
                }
              }
            }
          }
        },
        legend: {
          data: [
            {
              name: this.jinNangDetail.jinNangName,
              icon: 'circle'
            },
            {
              name: '沪深300',
              icon: 'circle'
            }
          ],
          top: '4%',
          right: '2%'
        },
        grid: {
          containLabel: true,
          left: '0px',
          right: '8px',
          bottom: '0px'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xaxisData
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              show: true,
              interval: 'auto',
              formatter: function(value, index) {
                // '{value} %'
                if (minValue < 0) {
                  return value + minValue + '%'
                } else {
                  return value + '%'
                }
              }
            },
            show: true
          }
        ],
        series: [
          {
            name: this.jinNangDetail.jinNangName,
            type: 'line',
            data: glYieldSeriesDataArr,
            color: 'rgb(4,107,204)',
            Symbol: 'none',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(4, 107, 204, 0.2)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'transparent' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          },
          {
            name: '沪深300',
            type: 'line',
            color: 'rgb(230,83,5)',
            data: indexSeriesDataArr,
            symbol: 'none'
          }
        ]
      }
      yieldChart.setOption(option)
    },
    async chartToggle() {
      this.ischartCollapse = !this.ischartCollapse
      if (!this.ischartCollapse) {
        await this.getYieldList(
          this.getFilterRange(this.currentRangeFilterIndex)
        )
      }
    },
    OnRepoClick(item) {
      this.$router.push(
        `/excl-author/jinnang/${this.currentJinNangId}/sale?stockId=${item.tr.stockId}&name=${item.tr.securitiesName}&isSell=true&code=${item.tr.securitiesCode}`
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.main-content {
  padding: 0px 40px 40px 40px;
}
.stat {
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cell {
  display: flex;
  flex-direction: column;
  height: 43px;
  justify-content: space-between;
}

.cell-split {
  flex-basis: 1px;
  background-color: #ebebeb;
  height: 43px;
}

.title {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 14px;
  letter-spacing: 0px;
  color: #858585;
  flex: none;
}
.value {
  font-family: MicrosoftYaHei;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  flex: none;
}

.hrsplit {
  height: 1px;
  background-color: #ebebeb;
}

.chart-content {
  height: 400px;
}

.chart-filter {
  display: flex;
  width: 350px;
  height: 30px;
  border-radius: 15px;
  margin-top: 40px;
  margin-left: 20px;
}

.filter-item:first-child {
  border-radius: 15px 0px 0px 15px;
  border-left: 1px solid #ebebeb;
}

.filter-item:last-child {
  border-radius: 0px 15px 15px 0px;
  border-right: 1px solid #ebebeb;
}

.filter-item {
  flex: 1 1 auto;
  height: 30px;
  text-align: center;
  font-size: 14px;
  color: #858585;
  line-height: 30px;
  cursor: pointer;
  letter-spacing: 0px;
  border: 1px solid #ebebeb;
  border-left: none;
}

.filter-select {
  background-color: rgba($color: #046bcc, $alpha: 0.1);
  color: #046bcc;
}
.collapse-tip {
  text-align: center;
  font-size: 13px;
  line-height: 30px;
  height: 30px;
  cursor: pointer;
  letter-spacing: 0px;
  color: rgb(4, 107, 204);
}

.colortip {
  color: rgb(4, 107, 204);
}

.mt40 {
  margin-top: 40px;
}
</style>
